import axios from "axios";
import { error_handle } from "../helpers/error";
import { deviceId } from "src/helpers/default";
import { getLocalPath } from "src/helpers/download";
class authen {

    getUser() {
        return axios.request({
            url: '/authentication/authen/getUser',
            method: 'get',
        })

            .then(response => {
                response = response['data'];
                return response;
            })

            .catch((error) => {
                return {
                    result: false,
                    message: error.message
                }
            })

    }

    refreshToken(handleError = true) {
        if (window.isRefreshingToken) return Promise.resolve(false)
        window.isRefreshingToken = true
        return axios.request({
            url: '/authentication/authen/refreshToken',
            method: 'post',
            data: {
                refresh_token: window.localStorage.getItem('refreshToken'),
            }
        })

            .then(response => {
                window.isRefreshingToken = false
                response = response['data'];
                if (response['result']) {
                    let token = response['data']['token']
                    let refreshToken = response['data']['refreshToken']
                    window.localStorage.setItem('token', token)
                    window.localStorage.setItem('refreshToken', refreshToken)
                    return response['data']
                }else{
                    throw new Error(response['message'] || 'Login failed')
                }
                
            })

            .catch((error) => {
                window.isRefreshingToken = false
                handleError && error_handle(error)
                return false
            })

    }





    login(username, password, nextLink, captchaData, remember = true, isLocal=true) {

        const formData = new URLSearchParams();
        formData.append('username', username);
        formData.append('password', password);
        formData.append('remember', remember);
        formData.append('device_id', deviceId());
        if (captchaData) {
            formData.append('captcha', captchaData['captcha']);
            formData.append('captcha_hash', captchaData['hash']);
        }

        return axios.request({
            url: '/authentication/authen/login',
            method: 'post',
            data: formData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })

            .then(response => {
                response = response['data'];
                if (response['result']) {
                    let token = response['data']['token']
                    let refreshToken = response['data']['refreshToken']
                    window.localStorage.setItem('token', token)
                    window.localStorage.setItem('refreshToken', refreshToken)
                    this.goto(nextLink, isLocal)
                }else{
                    throw new Error(response['message'] || 'Login failed')
                }

                return true
            })

            .catch((error) => {
                console.log(error);
                return error;
            })

    }

    logout() {

        return axios.request({
            url: '/authentication/authen/logout',
            method: 'post'
        })

            .then(response => {
                response = response['data'];
                localStorage.removeItem('token')
                localStorage.removeItem('refreshToken')
                window.location.reload()
            })

            .catch((error) => {
                console.log(error);
                return error;
            })

    }

    logoutAll() {

        return axios.request({
            url: '/authentication/authen/logoutAll',
            method: 'post'
        })

            .then(response => {
                response = response['data'];
                localStorage.removeItem('token')
                localStorage.removeItem('refreshToken')
                window.location.reload()
            })

            .catch((error) => {
                console.log(error);
                return error;
            })

    }

    changeInfo(username, password, confirm_value) {
        window.loading(true)
        return axios.request({
            url: '/authentication/authen/changeInfo',
            method: 'post',
            data: {
                username, password, confirm_value
            }
        })

            .then(response => {
                window.loading(false)
                response = response['data'];
                if (response['result']) {
                    return response['data']
                }
                error_handle(response)
            })

            .catch((error) => {
                window.loading(false)
                error_handle(error)
            })

    }


    sendResetPassEmail(email, captchaData, href) {
        window.loading(true, 'Sending email...')
        return axios.request({
            url: '/authentication/authen/sendResetPassEmail',
            method: 'post',
            data: {
                email,
                ...captchaData,
                href,
            }
        })

            .then(response => {
                window.loading(false)
                response = response['data'];
                if (response['result']) {
                    return response['data']
                }
                error_handle(response)
            })

            .catch((error) => {
                window.loading(false)
                error_handle(error)
                return false
            })

    }

    sendEmailVerifyCode(email, captchaData) {
        window.loading(true, 'Sending email...')
        return axios.request({
            url: '/authentication/authen/sendEmailVerifyCode',
            method: 'post',
            data: {
                email,
                ...captchaData,
            }
        })

            .then(response => {
                window.loading(false)
                response = response['data'];
                if (response['result']) {
                    return response['data']
                }
                error_handle(response)
            })

            .catch((error) => {
                window.loading(false)
                error_handle(error)
                return false
            })
    }

    updateEmail(verifyCode) {
        window.loading(true, 'Sending email...')
        return axios.request({
            url: '/authentication/authen/updateEmail',
            method: 'post',
            data: { verifyCode }
        })

            .then(response => {
                window.loading(false)
                response = response['data'];
                if (response['result']) {
                    return response['data']
                }
                error_handle(response)
            })

            .catch((error) => {
                window.loading(false)
                error_handle(error)
                return false
            })
    }


    resetPass(token, newPass, captchaData) {

        return axios.request({
            url: '/authentication/authen/resetPass',
            method: 'post',
            data: {
                token,
                newPass,
                ...captchaData
            }
        })

            .then(response => {
                response = response['data'];
                if (response['result']) {
                    return response['data']
                }
                error_handle(response)
            })

            .catch((error) => {
                error_handle(error)
            })

    }


    isSupportGoogle() {
        return axios.request({
            url: '/authentication/authen/google/is_support',
            method: 'get',
        })

            .then(response => {
                response = response['data'];
                if (response['result']) {
                    return response['data']
                } else {
                    return false
                }
            })

            .catch((error) => {
                error_handle(error)
                return false
            })
    }
    
    goto(nextLink, isLocal = true, blank=false) {
        return axios.request({
            url: '/authentication/authen/goto',
            method: 'get',
            params: {
                url: nextLink,
                isLocal
            }
        })

            .then(response => {
                response = response['data'];
                if (response['result']) {
                    let url = response['data']
                    if(isLocal){
                        if(blank){
                            window.open(url, '_blank')
                        }else{
                            window.location.href = url
                        }
                    }else{

                        let token = localStorage.getItem('token');
                        let refreshToken = localStorage.getItem('refreshToken');

                        // Tạo form
                        let form = document.createElement('form');
                        form.method = 'POST';
                        form.action = url;

                        // Token
                        let tokenInput = document.createElement('input');
                        tokenInput.type = 'hidden';
                        tokenInput.name = 'token';
                        tokenInput.value = token;
                        form.appendChild(tokenInput);

                        // Refresh Token
                        let refreshInput = document.createElement('input');
                        refreshInput.type = 'hidden';
                        refreshInput.name = 'refreshToken';
                        refreshInput.value = refreshToken;
                        form.appendChild(refreshInput);

                        // Thêm form vào DOM
                        document.body.appendChild(form);

                        // Submit
                        if (blank) {
                            form.target = '_blank';
                        }
                        form.submit();
                        document.body.removeChild(form);

                    }
                   


                } else {
                    
                }
            })

            .catch((error) => {
                error_handle(error)
                return false
            })
    }

}

export default authen